import { Outlet, useOutletContext, useParams } from 'react-router-dom'

import { GetTaskConfigurationSettingsQuery } from 'generated/resources/graphql'

import { LoadingState } from 'modules/processes/components/LoadingState'
import { Template } from 'modules/processes/domain'
import { useGetTaskConfigurationSettings } from 'modules/processes/hooks/useGetTaskConfigurationSettings'
import { useProcess } from 'modules/processes/hooks/useProcess'
import type { Process } from 'modules/processes/hooks/useProcesses'
import { useTemplate } from 'modules/processes/hooks/useTemplate'

type ProcessesTaskConfigurationSetting = NonNullable<
  NonNullable<GetTaskConfigurationSettingsQuery['processes']['taskConfigurationSettings']>[number]
>

export const useProcessContext = () => {
  return useOutletContext<{
    process: Process
    template?: Template
    taskConfigurationSettings?: ProcessesTaskConfigurationSetting
  }>()
}

const ProcessRootPage = () => {
  const { id, category } = useParams()

  // We only need the basic info loaded here to navigate,
  // the details are only needed in the settings page
  const { loading, process } = useProcess(String(id))
  const { loading: taskSettingsLoading, settings } = useGetTaskConfigurationSettings({
    category: category!,
  })
  const { template } = useTemplate(process?.category ?? '')

  if (loading || taskSettingsLoading) return <LoadingState />

  return <Outlet context={{ process: process, template, taskConfigurationSettings: settings }} />
}

export default ProcessRootPage
